/* eslint-disable require-jsdoc */
import {Buffer} from 'buffer';
import {getSignedUrl} from '@/services/maintenance.js';
import axios from 'axios';

const getObjectUrl = async (key) => {
  const url = await getSignedUrl({
    key,
    method: 'get',
  });
  return url;
};

const putObject = async ({key, arrayBuffer}) => {
  const url = await getSignedUrl({
    key,
    method: 'put',
  });
  const Body = Buffer.from(arrayBuffer);
  await axios.put(url, Body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export {getObjectUrl, putObject};
